import React from 'react'
import classNames from 'classnames'
import './Checkbox.scss'

export const Checkbox = ({ checked, disabled, label, classnames, className, id, ...props }) => {
  const containerClassName = classNames(['checkbox-button', 'relative', 'flex', 'ai-center', 'opacity-80__hover', 'transition-regular'], classnames?.container, className, {
    'opacity-40 pinter-events-none': disabled,
  })

  const labelClassName = classNames(['relative', 'flex', 'ai-center', 'transition-inherit', 'h-24'], classnames?.label, disabled ? 'pointer-events-none' : 'cursor-pointer', label ? 'w-100' : 'w-24')

  return (
    <div className={containerClassName}>
      <input type='checkbox' id={id} className='none' checked={checked} {...props} />
      <label htmlFor={id} className={labelClassName}>
        {label}
      </label>
    </div>
  )
}

export default Checkbox

